import { useStore } from 'effector-react'
import { rentalContractModel } from '~/entities/RentalContract'
import { formatDateForUI } from '~/shared/lib/date'
import { replaceFx } from '~/shared/lib/history'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { useDrawer } from '~/shared/ui/Drawer'
import { ArrowRightIcon, PlusSquareIcon } from '~/shared/ui/icons'
import { useStorageRepeatCode } from '~/shared/ui/RepeatCode'
import { ConfirmDrawer } from './ConfirmDrawer'
import {
  TIMER_REPEAT_RENTAL_CONTRACT_SIGNING,
  TIMER_REPEAT_RENTAL_CONTRACT_SIGNING_TIME,
} from './constants'
import {
  loadRentalContractFileFx,
  loadRentalContractFile,
  confirmCode,
  confirmCodeFx,
  confirm,
  confirmFx,
} from './model'
import {
  FileButton,
  SignButton,
  RentalContractWrapper,
  TitleWrapper,
  AlertDescriptions,
  AlertIcon,
  AlertWrapper,
  CreatedAd,
  Title,
} from './styled'

export function RentalContractSigning() {
  const rentalContract = useStore(rentalContractModel.$rentalContract)

  const createdAd = rentalContract?.getCreatedAt()

  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  const { runTimer, getIsTimerWorking } = useStorageRepeatCode(
    TIMER_REPEAT_RENTAL_CONTRACT_SIGNING,
  )
  const confirmCodePending = useStore(confirmCodeFx.pending)
  const confirmPending = useStore(confirmFx.pending)
  const isRentalContractFilePending = useStore(loadRentalContractFileFx.pending)

  const warningRequestCod = () => {
    snackbarEnqueued({
      message:
        'Запросите код повторно после того как пройдет блокировка получения кода',
      variant: 'warning',
    })
  }

  const handleCodeRequest = () => {
    if (getIsTimerWorking()) {
      warningRequestCod()
      openDrawer()
    } else {
      confirmCode({
        fn: () => {
          runTimer(TIMER_REPEAT_RENTAL_CONTRACT_SIGNING_TIME)
          openDrawer()
        },
      })
    }
  }

  const handleConfirm = (code: string) => {
    confirm({
      code,
      fn: () => {
        closeDrawer()
        replaceFx('/')
      },
    })
  }

  return (
    <>
      <RentalContractWrapper>
        <TitleWrapper>
          <Title>
            Договор <br />
            оказания услуг
          </Title>

          {createdAd && <CreatedAd>От {formatDateForUI(createdAd)}</CreatedAd>}
        </TitleWrapper>
        <FileButton
          variant='limeFlooded'
          startDecorator={!isRentalContractFilePending && <ArrowRightIcon />}
          onClick={() => loadRentalContractFile()}
          loading={isRentalContractFilePending}
          contentProps={{
            style: {
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          Просмотреть
        </FileButton>
      </RentalContractWrapper>

      <AlertWrapper>
        <AlertIcon>
          <PlusSquareIcon />
        </AlertIcon>
        <AlertDescriptions>
          Обратите внимание, что дополнительно к стоимости аренды будут
          добавлены обязательные услуги: нулевой риск, мед. осмотр и тех.осмотр.
          Списания по этим услугам происходят ежедневно.
        </AlertDescriptions>
      </AlertWrapper>

      <SignButton
        size='large'
        variant='limeFlooded'
        onClick={handleCodeRequest}
        loading={confirmCodePending}
        fullWidth
      >
        Подписать
      </SignButton>

      <ConfirmDrawer
        onOk={handleConfirm}
        isShow={isDrawerShow}
        onCancel={closeDrawer}
        isSubmitting={confirmPending}
        onCodeRepeat={handleCodeRequest}
      />
    </>
  )
}
